import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {
  DEFAULT_METHOD_TEXT_PROFILE,
  METHOD_TEXT_PROFILE_IDENTIFIERS,
  MethodTextProfileIdentifier,
  MethodTextProfilesResponse,
} from '../types/MethodTextProfileTypes';

import {useApiRead} from '../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';

export const useMethodTextProfileOptions = () => {
  const {t} = useTranslation('translation', {keyPrefix: 'companySettings.departments.methodTextProfile'});
  const {data, isLoading, error} = useApiRead<MethodTextProfilesResponse>({
    path: GetRoutes.methodTextProfiles,
  });

  const identifiers = useMemo((): MethodTextProfileIdentifier[] => {
    const fromApi = data?.map((profile) => profile.identifier);
    if (fromApi?.length) {
      return fromApi;
    }
    return METHOD_TEXT_PROFILE_IDENTIFIERS;
  }, [data]);

  const options = useMemo(
    () =>
      identifiers.map((identifier) => ({
        id: identifier,
        label: t(identifier) || identifier,
      })),
    [identifiers, t]
  );

  return {
    options,
    defaultProfile: DEFAULT_METHOD_TEXT_PROFILE,
    isLoading,
    error,
  };
};
